import React, { createContext, useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const HospitalContext = createContext()

export const HospitalProvider = ({ children }) => {
    const [selectedHospital, setSelectedHospital] = useState({})
    const authReducer = useSelector((state) => state.authReducer);

    useEffect(() => {
        const hospitalId = localStorage.getItem("hospitalId")
        if (!hospitalId) return;
        const hospitals = authReducer?.userAttributes?.hospitals
        if (!hospitals || hospitals.length === 0) return;
        const matchedHospital = hospitals.find(h => h.id === hospitalId)
        if (matchedHospital) {
            setSelectedHospital(matchedHospital)
        }
    }, [authReducer.userAttributes])

    return (
        <HospitalContext.Provider value={{ selectedHospital, setSelectedHospital }}>
            {children}
        </HospitalContext.Provider>
    )
}

export const useHospitalContext = () => useContext(HospitalContext)